import { Injectable} from '@angular/core';
import { IUserService } from './user.type';
import { ExistingUserRegistrationFormPayload } from '../../models/API.models';
import { APIJoinFlowService } from '../API/APIJoinFlow.service';
import { NGXLogger } from 'ngx-logger';
import { TokenService } from '../auth/token.service';
import { FormGroup } from '@angular/forms';
import { FormService } from './form.service';
import { AmplifyErrorStrings, AppErrorCode } from '../error/error.constants';

@Injectable({
  providedIn: 'root'
})
export class UserService implements IUserService {
  constructor(
    private apiJoinFlowService: APIJoinFlowService,
    private logger: NGXLogger,
    private tokenService: TokenService,
    private formService: FormService,
  ) { }

  async registerExistingUser(formPayload: Partial<ExistingUserRegistrationFormPayload>, form: FormGroup): Promise<boolean> {
    this.logger.debug('[UserService] - [Form Submit] registerExistingUser starts.');

    this.formService.setForm(form);

    try {
      const resp = await this.apiJoinFlowService.submitForm(formPayload);

      this.logger.debug('[UserService] [Form Submit] - response: ', resp);
      this.logger.debug('response user status: ', resp['amilearn-status']);

      this.tokenService.setUserStatus(resp['amilearn-status']);
      return true;
    } catch (error) {
      this.logger.error('[UserService] - [Form Submit] error: ', error);

      if (typeof error === 'string') {
        const errString = error as string;
        const appError =
          (errString === AmplifyErrorStrings.AUTH_ERROR_STRING)
          ? AppErrorCode.AUTH_ERROR
          : AppErrorCode.UNKNOWN_ERROR;

        throw new Error(errString, {cause: appError});
      }
      else {
        throw error;
      }
    }
  }

  async testProtectedAPI(): Promise<boolean> {
    try {
      this.logger.debug('[Test API] testProtectedAPI starts.');
      const resp = await this.apiJoinFlowService.testProtectedAPI();

      this.logger.debug('[Test API]', resp);
      return true;
    } catch (err) {
      this.logger.debug('[Test API]', err);
      return false;
    }
  }
}
